/* eslint-disable no-await-in-loop */
export const asyncForEach = async (array, callback) => {
	for (let index = 0; index < array.length; index += 1) {
		await callback(array[index], index, array);
	}
};
